<template>
  <div class="testimonials-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-md-4 mb-4" v-for="(testimonial, index) in testimonials" :key="index">
          <div class="testimonial-card">
            <div class="quote-icon" :style="{ color: testimonial.accentColor }">
              "
            </div>
            <div class="testimonial-text">
              {{ testimonial.text }}
            </div>
            <div class="testimonial-author">
              <div class="author-avatar-icon">
                <img v-if="testimonial.avatar" :src="testimonial.avatar" :alt="testimonial.name" />
                <svg v-else viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <div class="author-info">
                <div class="author-name">{{ testimonial.name }}</div>
                <div class="author-role">{{ testimonial.role }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const testimonials = computed(() => {
  const enTestimonials = [
    {
      text: "\"The app is great. It's super easy to navigate and really helps making you feel more secure and confident. The conversation with the AI tool creates a calm atmosphere and makes you feel like you're talking to a real therapist. It also backs up its statements with scientific facts. Love it, would highly recommend!\"",
      name: "Yoana",
      role: "Mother of one",
      avatar: "/static/testimonials/yoana_testimonial.jpeg",
      accentColor: "#6B6B9C"
    },
    {
      text: "\"Momfident is like that quiet, understanding friend who's there for you at 3 a.m. when you're wondering if you're doing okay. It doesn't solve everything for you, but it helps you organize your thoughts and reminds you that you're not alone in the chaos of motherhood.\"",
      name: "Delyana",
      role: "Mother of one",
      avatar: "/static/testimonials/delyana.jpg",
      accentColor: "#EA708C"
    },
    {
      text: "\"I was skeptical at first, but I ended up pleasantly surprised. The app has a genuinely great purpose and feels very supportive. It made me reflect on things I can change.\"",
      name: "Anonymous user",
      role: "Mother of two",
      avatar: "",
      accentColor: "#FFB6C1"
    }
  ];

  const bgTestimonials = [
    {
      text: "\"Приложението е страхотно. Изключително лесно е за навигация и наистина ми помага да се почувствам по-спокойна, уверена и сигурна. Разговорът с AI инструмента създава спокойна атмосфера и те кара да се чувстваш сякаш говориш с истински терапевт. Освен това твърденията са подкрепени с научни факти. Много ми харесва и го препоръчвам силно!\"",
      name: "Йоана",
      role: "Майка на едно дете",
      avatar: "/static/testimonials/yoana_testimonial.jpeg",
      accentColor: "#6B6B9C"
    },
    {
      text: "\"Momfident е като онзи тих, разбиращ приятел, който е до теб в 3 през нощта, когато се чудиш дали се справяш. Не решава всичко вместо теб, но ти помага да подредиш мислите си и да си спомниш, че не си сама в хаоса на майчинството.\"",
      name: "Деляна",
      role: "Майка на едно дете",
      avatar: "/static/testimonials/delyana.jpg",
      accentColor: "#EA708C"
    },
    {
      text: "\"Първоначално бях скептична, но останах приятно изненадана. Приложението има наистина добра цел и е много подкрепящо. Накара ме да се замисля за неща, които мога да променя.\"",
      name: "Анонимен потребител",
      role: "Майка на две деца",
      avatar: "",
      accentColor: "#FFB6C1"
    }
  ];

  return locale.value === 'bg' ? bgTestimonials : enTestimonials;
});
</script>

<style lang="scss" scoped>
.testimonials-wrapper {
  padding: 60px 0;
  background-color: #FFFFFF;
}

.testimonial-card {
  background-color: #FFFFFF;
  border: 1px solid #F0F0F0;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }

  .quote-icon {
    font-size: 80px;
    font-weight: bold;
    line-height: 0.7;
    margin-bottom: 15px;
    font-family: Georgia, serif;
    opacity: 0.8;
  }

  .testimonial-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    color: #4A4A4A;
    margin-bottom: 20px;
    flex-grow: 1;
  }

  .testimonial-author {
    display: flex;
    align-items: center;
    gap: 15px;

    .author-avatar-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: #E0E0E0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      svg {
        width: 28px;
        height: 28px;
        color: #9E9E9E;
      }
    }

    .author-info {
      .author-name {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 4px;
      }

      .author-role {
        font-size: 16px;
        font-weight: 400;
        color: #6C757D;
      }
    }
  }
}

@media (max-width: 768px) {
  .testimonials-wrapper {
    padding: 40px 0;
  }

  .testimonial-card {
    padding: 25px;
    
    .quote-icon {
      font-size: 48px;
    }

    .testimonial-text {
      font-size: 14px;
    }

    .testimonial-author {
      .author-avatar-icon {
        width: 45px;
        height: 45px;

        svg {
          width: 24px;
          height: 24px;
        }
      }

      .author-info {
        .author-name {
          font-size: 16px;
        }

        .author-role {
          font-size: 14px;
        }
      }
    }
  }
}
</style>

